/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskWaveOverviewEntry } from './ExecRiskWaveOverviewEntry';
import {
    ExecRiskWaveOverviewEntryFromJSON,
    ExecRiskWaveOverviewEntryFromJSONTyped,
    ExecRiskWaveOverviewEntryToJSON,
} from './ExecRiskWaveOverviewEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedWaveResponse
 */
export interface ExecRiskPaginatedWaveResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWaveResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskWaveOverviewEntry>}
     * @memberof ExecRiskPaginatedWaveResponse
     */
    results: Array<ExecRiskWaveOverviewEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedWaveResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWaveResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedWaveResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedWaveResponse interface.
 */
export function instanceOfExecRiskPaginatedWaveResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedWaveResponseFromJSON(json: any): ExecRiskPaginatedWaveResponse {
    return ExecRiskPaginatedWaveResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedWaveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedWaveResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskWaveOverviewEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedWaveResponseToJSON(value?: ExecRiskPaginatedWaveResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskWaveOverviewEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

